import { render, staticRenderFns } from "./ShowGroup.vue?vue&type=template&id=c5c5c008&scoped=true&"
import script from "./ShowGroup.vue?vue&type=script&lang=js&"
export * from "./ShowGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c5c008",
  null
  
)

export default component.exports